import React from 'react'
import { Button } from '@mui/material'
import { Link } from 'react-router-dom'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import useStyle from 'shared/hooks/useStyle'

import { useTranslation } from 'shared/hooks/useSafeTranslation'
import TwoRowErrorPage from 'shared/ErrorPages/TwoRowErrorPage'
import styles from './NoOrders.style'

const NoOrders = () => {
    const { t } = useTranslation()
    const classes = useStyle(styles)

    return (
        <TwoRowErrorPage
            message={t('NO_ORDERS_MESSAGE')}
            iconPath="skycenter/sleeping_robot.svg"
            iconAlt="logo"
        >
            <Button
                data-testid="back-button"
                component={Link}
                to="/mainDashboard"
                css={classes.button}
                startIcon={<ArrowBackIcon />}
            >
                {t('BACK')}
            </Button>
        </TwoRowErrorPage>
    )
}

export default NoOrders
